import React from 'react';
import PropTypes from 'prop-types';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

export const VpSelect = ({ options, ...rest }) => {
  return (
    <Select {...rest}>
      {options.map((opt) => (
        <MenuItem key={opt?.id || opt} value={opt.id || opt} disabled={opt?.disabled}>
          {opt.label || opt}
        </MenuItem>
      ))}
    </Select>
  );
};

VpSelect.propTypes = {
  options: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        label: PropTypes.string
      })
    ),
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number]))
  ])
};

export default VpSelect;



// WEBPACK FOOTER //
// ./src/vp-ui/inputs/VpSelect.jsx